/**
 * Board layout for the play page: square tiles or interlocking knobs.
 * Reads optional explicit fields first, then falls back to legacy `selected_jigsaw_type`.
 */

export const PUZZLE_SHAPE_LABELS = {
  square: "Square",
  interlock: "Interlocking",
};

export const PUZZLE_SHAPE_OPTIONS = [
  { value: "square", label: "Square" },
  { value: "interlock", label: "Interlocking" },
];

export function pickPuzzleTypeFromThemeData(themeData) {
  if (!themeData) return "interlock";
  const norm = (v) => (typeof v === "string" ? v.toLowerCase().trim() : "");
  const explicit =
    norm(themeData.selected_puzzle_shape) || norm(themeData.puzzle_shape);
  if (explicit === "square" || explicit === "interlock") {
    return explicit;
  }
  /** Legacy honeycomb / hex values map to interlock. */
  if (explicit === "honeycomb" || explicit === "hex") return "interlock";

  const jig = norm(themeData.selected_jigsaw_type);
  if (jig === "square") return "square";
  if (jig === "honeycomb" || jig === "hex") return "interlock";

  return "interlock";
}
